export function getDaysStyle(
  isToday: boolean,
  isInSelectedMonth: boolean,
): string {
  const baseClasses = 'py-0.5 rounded-md';
  if (isToday)
    return `${baseClasses} bg-primary-blue-B600 text-white w-6 text-center px-0.5`;
  if (!isInSelectedMonth)
    return `${baseClasses} bg-transparent text-neutrals-N700`;
  return `${baseClasses} bg-transparent text-neutrals-N900`;
}
